import { useEffect, useState, type FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import AssignToMyTeam from './AssignToMyTeam';
import MyTeamList from './MyTeamList';

const MyTeam: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showAssignComponent, setShowAssignComponent] = useState<boolean>(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const assign = params.get('assign') === 'true';
    setShowAssignComponent(assign);
  }, [location.search]);

  const handleCancel = (): void => {
    const params = new URLSearchParams(location.search);
    params.delete('assign');
    navigate({
      pathname: location.pathname,
      search: params.toString(),
    });
    setShowAssignComponent(false);
  };

  if (showAssignComponent) {
    return <AssignToMyTeam onCancel={handleCancel} />;
  }

  return <MyTeamList />;
};

export default MyTeam;
